<!--
 * @Author: Gaho
 * @Date: 2024-06-20 13:39:35
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-06 16:57:29
 * @Description: 
-->
<template>
    <Modal
        v-bind="$attrs"
        :model-value="modelValue"
        :container-class="`modalHeader ${containerClass} ${slots.footer ? '!p-0' : ''}`"
        v-if="modelValue"
        @click.self="() => onBackdrop()"
        class="w-full"
    >
        <!-- Header -->
        <div
            v-if="slots.header"
            :class="[slots.footer ? 'p-3' : 'p-0']"
            class="!z-20 py-[16px] px-[16px] text-2xl relative items-center text-white font-bold flex justify-center"
        >
            <slot name="header"></slot>
            <QIcon
                name="close"
                class="absolute text-[#93acd3] right-[20px] top-[20px] cursor-pointer"
                @click="close"
            />
        </div>
        <div
            v-else
            class="text-3xl py-[20px] px-[24px] font-bold !z-20 relative text-white"
            :class="[slots.footer ? 'p-3' : 'p-0']"
        >
            <span class="text-[32px]">{{ title }}</span>
            <QIcon
                name="close"
                class="absolute text-[#93acd3] right-[15px] top-[15px] cursor-pointer"
                @click="close"
            />
        </div>

        <!-- Body -->
        <div class="px-[24px] pb-[20px]">
            <slot class="relative"></slot>
        </div>

        <!-- Footer -->
        <div
            v-if="slots.footer"
            :class="footerClass"
            class="flex left-0 right-0 rounded-b-2xl bg-[#161F2CFF] py-[16px] px-[24px] gap-[8px]"
        >
            <slot name="footer"></slot>
        </div>
    </Modal>
</template>


<script lang="ts" setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: '',
    },
    containerClass: {
        type: String,
        default: '',
    },
    footerClass: {
        type: String,
        default: '',
    },
});
const slots = useSlots();
const { modelValue: toRefModelValue } = toRefs(props);

const emit = defineEmits(['update:modelValue','hideModel']);
const close = () => {
    emit('update:modelValue', false);
    emit('hideModel')
};
const onBackdrop = () => {
    if (props.backdrop) {
        close();
    }
};
watch(
    () => props.modelValue,
    (value) => {
        if (value) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    },
);
</script>

<style>
.modalHeader::before {
    background: linear-gradient(180deg, #003370, transparent);
    border-radius: 14px 14px 0 0;
    content: '';
    display: block;
    height: 72px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
}
</style>

